	<div class="kt-grid kt-grid--ver kt-grid--root">
			<div class="kt-grid__item kt-grid__item--fluid kt-grid  kt-error-v6" style="background-image: url(assets/image/develop.jpg);">
				<div class="kt-error_container">
					<p class="kt-error_description kt-font-light">
						We're working on it
					</p>
				</div>
			</div>
		</div>